import _extends from "@babel/runtime/helpers/esm/extends";
import * as React from 'react';
import { SvgIcon } from "../SvgIcon";
export var Facebook = function Facebook(props) {
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.498 16V8.702h2.498l.373-2.845H9.5V4.041c0-.823.232-1.384 1.436-1.384h1.536V.111A20.921 20.921 0 0010.233 0c-2.214 0-3.73 1.326-3.73 3.76v2.097H4v2.845h2.504V16h2.994z",
    fill: "currentColor"
  }));
};
export default Facebook;